export function initPagination() {
  return {
    currentPage: 1,
    totalRows: 1,
    perPage: 10
  }
}

export function ObjectAssign(target, source) {
  Object.getOwnPropertyNames(target)
    .forEach(property => {
      // eslint-disable-next-line no-prototype-builtins
      if (source && source.hasOwnProperty(property)) {
        target[property] = source[property]
      }
    })
  return target
}

export async function delay(seconds) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve()
    }, seconds * 1000)
  })
}
